import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { nearestDoctorListingApi } from "../../../api/leadApi/leadApi";
import ProvidersMap from "../../../components/formSort/providersMap/ProvidersMap";
import "./CustomMapLocation.css";
import userImage from "../../../assets/user-img.jpg";
import useEncryption from "../../../services/useEncryption";
import CircularProgress from "@mui/material/CircularProgress";
import path from "../../../path";
import Box from "@mui/material/Box";
import {
  setAnswerValue,
  getAnswerValue,
  clearAnswerValue,
  getSemanticAnswerValue,
  getAllAnswerValues,
  getResponderUuid,
  setDisableBackNavigation,
} from "@formsort/custom-question-api";

const CustomMapLocation = () => {
  const { zipcode } = useParams();
  const {country_of_residence_,Enter_firstname,Enter_lastname,age,age_category}=useParams();
  const { decryptData } = useEncryption();
  const [providers, setProviders] = useState([]);
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchProviders = async () => {
      setLoading(true);
      try {
        console.log("Fetching providers for country_of_residence_,Enter_firstname,Enter_lastname,age,age_category,categoryAge====================:", country_of_residence_,Enter_firstname,Enter_lastname,age,age_category);
        const response = await nearestDoctorListingApi(zipcode,country_of_residence_,Enter_firstname,Enter_lastname,age,age_category);
        const decryptedData = decryptData(response.data.data);
        console.log("Decrypted Providers Data:", decryptedData);

        const formattedProviders = decryptedData.map((provider) => ({
          ...provider,
          latitude: parseFloat(provider.latitude),
          longitude: parseFloat(provider.longitude),
        }));
        console.log("Formatted Providers Data:", formattedProviders);

        setProviders(formattedProviders);
      } catch (error) {
        console.error("Error fetching providers:", error);
      } finally {
        setLoading(false);
      }
    };

    if (zipcode) {
      fetchProviders();
    }
  }, [zipcode]);

   const handleDoctorClick = async (locationId) => {
      try {
        setSelectedProviderId(locationId);
        await setAnswerValue(locationId );
      
      } catch (error) {
        console.error('Error setting provider ID:', error);
      }
    };


  return (
    <>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      ) : providers.length > 0 ? (
        <>
          <ProvidersMap providers={providers} />
          <p className="heading">Select your preferred provider</p>
          {providers.map((provider, index) => (
            <div
              key={index}
              className={`listing-div ${selectedProviderId === provider.providerId ? "selected" : ""
                }`}
              // onClick={() => handleDoctorClick(provider.locationId)}
              onClick={() => handleDoctorClick(provider.locationId)}

            >
              <div className="profile-image-div">
                <img
                  src={
                    provider?.doctor?.photo && provider?.doctor?.photo !== null
                      ? `${path}/${provider?.doctor?.photo.replace(
                        "public/images/UserIcons/",
                        ""
                      )}`
                      : userImage
                  }
                  alt={`Provider ${index + 1}`}
                  className="profile-image"
                />
              </div>
              <div className="info-div">
                <p className="doctor-name">
                  <strong>
                    Dr.{" "}
                    {`${provider?.doctor?.firstName
                      .charAt(0)
                      .toUpperCase()}${provider?.doctor?.firstName
                        .slice(1)
                        .toLowerCase()}`}
                    {` ${provider?.doctor?.lastName
                      .charAt(0)
                      .toUpperCase()}${provider?.doctor?.lastName
                        .slice(1)
                        .toLowerCase()}`}
                  </strong>
                </p>
                <p>
                  {provider?.city}, {provider?.state} . {provider?.distance}
                </p>
              </div>
            </div>
          ))}
        </>
      ) : (
        <p className="no-doctor-message">
          No nearby doctors were found for this ZIP code. Try a different ZIP code to search again.
        </p>
      )}
    </>
  );
};

export default CustomMapLocation;
